export default __webpack_public_path__ + "static/media/notification-list-mobile.a01fc1e5.png";